// @see app/graphql/application/types/room_type_enum_type.rb
export enum RoomType {
  ContentLink = 'content_link',
  Deal = 'deal',
  Company = 'company',
  General = 'general',
}
